import { Component } from "react";

import DataTable from "components/DigiHapi/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// DigiHapi components
import ConfirmDialog from "components/DigiHapi/ConfirmDialog";
import MDWizard from "components/DigiHapi/MDWizard";
import Notification from "components/DigiHapi/Notification";

import { VscDebugStepInto } from "react-icons/vsc";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
	fetchGetEquipments,
	fetchAddEquipment,
	fetchUpdateEquipment,
	fetchDeleteEquipment
} from "actions/equipment";

import Step1 from "./Step1";
import Step2 from "./Step2";

import {
	RESET_EQUIPMENT,
	SET_EQUIPMENT,
	SET_EQUIPMENT_WIZARD_STEP,
	SET_EQUIPMENT_NAME_FR,
	SET_EQUIPMENT_NAME_EN,
	SET_EQUIPMENT_ORDER,
	SET_EQUIPMENT_SYSTEM,
	ROLE_WEBMASTER
} from "actions/types";

class PlaceWizard extends Component {
	fetchAddEquipment = () => {
		const { fetchAddEquipment, name, lang, system, community } = this.props;

		fetchAddEquipment({ name, lang, system, communityId: community._id });
	};

	fetchUpdateEquipment = () => {
		const { fetchUpdateEquipment, _id, name, lang, order, system } = this.props;

		fetchUpdateEquipment({ _id, name, lang, order, system });
	};

	render() {
		const {
			update,
			isFetching,
			onClose,
			onChangeCurrentStep,
			wizardCurrentStep
		} = this.props;

		return (
			<Grid item xs={12}>
				<MDWizard
					onClose={onClose}
					onChangeCurrentStep={onChangeCurrentStep}
					currentStep={wizardCurrentStep}
					isFetching={isFetching}
					validate
					steps={[
						{
							stepName: "Français",
							stepComponent: Step1,
							stepId: "french"
						},
						{
							stepName: "Anglais",
							stepComponent: Step2,
							stepId: "english"
						}
					]}
					title={
						update ? "Mise à jour d'un équipement" : "Ajout d'un équipement"
					}
					finishButtonClick={
						update ? this.fetchUpdateEquipment : this.fetchAddEquipment
					}
				/>
			</Grid>
		);
	}
}

class PlacesPage extends Component {
	state = {
		br: false,
		color: "info",
		message: null,
		wizard: null,
		equipmentToDelete: null
	};

	componentDidMount() {
		const { fetchGetEquipments, community, newWizard } = this.props;
		fetchGetEquipments(community._id);
		if (newWizard) {
			this.addWizard(newWizard === "update");
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			fetchGetEquipments,
			snackErrorMsg,
			snackInfoMsg,
			newWizard,
			community
		} = this.props;

		if (snackErrorMsg && prevProps.snackErrorMsg !== snackErrorMsg) {
			this.autoCloseMessage();
		}

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			this.setState({
				wizard: null
			});
			fetchGetEquipments(community._id);
			this.autoCloseMessage();
		}

		if (newWizard && prevProps.newWizard !== newWizard) {
			this.addWizard(newWizard === "update");
		}
	}

	hideAlert = () => {
		this.setState({
			br: false
		});
	};

	autoCloseMessage = () => {
		const { snackErrorMsg, snackInfoMsg } = this.props;

		this.setState({
			br: true,
			message: snackInfoMsg ? snackInfoMsg : snackErrorMsg,
			color: snackInfoMsg ? "info" : "danger"
		});

		if (snackInfoMsg) {
			setTimeout(this.hideAlert, 5000);
		}
	};

	onClose = () => {
		this.setState({
			wizard: null
		});
		this.props.dispatch({
			type: RESET_EQUIPMENT
		});
	};

	onChangeCurrentStep = currentStep => {
		this.props.dispatch({
			type: SET_EQUIPMENT_WIZARD_STEP,
			payload: currentStep
		});
	};

	addWizard = (update = true) => {
		this.setState({
			wizard: (
				<ConnectedPlaceWizard
					update={update}
					onClose={this.onClose}
					onChangeCurrentStep={this.onChangeCurrentStep}
				/>
			)
		});
	};

	editEquipment = (id, name, lang, order, system) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_EQUIPMENT,
			payload: id
		});
		dispatch({
			type: SET_EQUIPMENT_NAME_FR,
			payload: name
		});
		if (lang && lang.en) {
			dispatch({
				type: SET_EQUIPMENT_NAME_EN,
				payload: lang.en.name
			});
		}
		dispatch({
			type: SET_EQUIPMENT_ORDER,
			payload: order
		});
		dispatch({
			type: SET_EQUIPMENT_SYSTEM,
			payload: system
		});
	};

	deleteEquipment = id => {
		this.props.fetchDeleteEquipment(id);
	};

	getRoundButtons = (id, name, lang, order, communityId, system) => {
		const { user } = this.props;
		if ((system && user.role === ROLE_WEBMASTER) || !system) {
			return [
				{
					color: system ? "primary" : "info",
					icon: "edit",
					onClick: this.editEquipment
				},
				{ color: "error", icon: "delete", onClick: this.delete }
			].map((prop, key) => {
				return (
					(user.role === ROLE_WEBMASTER || communityId) && (
						<MDButton
							variant="gradient"
							size="small"
							iconOnly
							circular
							color={prop.color}
							disabled={!!this.state?.wizard}
							key={key}
							onClick={() => prop.onClick(id, name, lang, order, system)}
							sx={{ mx: 0.25 }}
						>
							<Icon>{prop.icon}</Icon>
						</MDButton>
					)
				);
			});
		}
	};

	getPlaces = () => {
		const { equipments } = this.props;

		return (
			equipments &&
			equipments.map(({ _id, name, lang, order, communityId, system }) => {
				return {
					name,
					actions: (
						<MDBox display="flex" justifyContent="flex-end">
							{this.getRoundButtons(
								_id,
								name,
								lang,
								order,
								communityId,
								system
							)}
						</MDBox>
					)
				};
			})
		);
	};

	delete = equipmentId => {
		this.setState({ equipmentToDelete: equipmentId });
	};

	render() {
		const { color, message, wizard, equipmentToDelete } = this.state;
		const { dispatch, isFetchingList, user } = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<Card>
						<MDBox
							mx={2}
							mt={-3}
							py={2}
							px={2}
							variant="gradient"
							bgColor="primary"
							borderRadius="lg"
							coloredShadow="primary"
							display="flex"
							alignItems="center"
							color="white"
						>
							<VscDebugStepInto size={24} />
							<MDTypography variant="h6" color="white" ml={1.5}>
								{"Lieux de rendez-vous"}
							</MDTypography>
						</MDBox>
						<MDBox p={2}>
							<DataTable
								data={this.getPlaces()}
								filterable
								columns={[
									{
										Header: "Nom",
										accessor: "name",
										sortable: true,
										filterable: false
									},
									{
										Header: "Actions",
										accessor: "actions",
										sortable: false,
										filterable: false
									}
								]}
								loading={isFetchingList}
								defaultPageSize={5}
								showPaginationTop
								showPaginationBottom={false}
								previousText="Précédent"
								nextText="Suivant"
								rowsText="Lignes"
								noDataText="Aucuns lieux de rendez-vous"
								ofText="sur"
								loadingText="Chargement..."
							/>
						</MDBox>
						<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
							{user.role === ROLE_WEBMASTER && (
								<MDButton
									variant="gradient"
									color="info"
									onClick={() =>
										dispatch({
											type: SET_EQUIPMENT_SYSTEM,
											payload: true
										})
									}
									disabled={!!wizard}
								>
									<Icon>add</Icon>&nbsp;{"Ajout d'un lieu de rdv sytème"}
								</MDButton>
							)}
							<MDButton
								variant="gradient"
								color="primary"
								onClick={() =>
									dispatch({
										type: SET_EQUIPMENT_SYSTEM,
										payload: false
									})
								}
								disabled={!!wizard}
							>
								<Icon>add</Icon>&nbsp;{"Ajout d'un lieu de rdv"}
							</MDButton>
						</MDBox>
					</Card>
				</Grid>
				{wizard}
				<ConfirmDialog
					open={!!equipmentToDelete}
					message="Êtes-vous sûr de vouloir supprimer le lieu de rendez-vous ?"
					confirmText="Supprimer"
					onCancel={() => this.setState({ equipmentToDelete: null })}
					onConfirm={() => {
						this.deleteEquipment(equipmentToDelete);
						this.setState({ equipmentToDelete: null });
					}}
				/>
				<Notification
					place="br"
					color={color}
					message={message}
					open={this.state.br}
					onClose={this.hideAlert}
				/>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		isFetchingList,
		isFetching,
		_id,
		equipments,
		name,
		lang,
		order,
		error,
		nameError,
		snackInfoMsg,
		snackErrorMsg,
		newWizard,
		system,
		wizardCurrentStep
	} = state.equipmentReducer;
	const { community } = state.entitiesReducer;
	const { user } = state.profileReducer;
	return {
		isFetchingList,
		isFetching,
		_id,
		equipments: equipments && Object.values(equipments),
		name,
		lang,
		order,
		error,
		nameError,
		snackInfoMsg,
		snackErrorMsg,
		newWizard,
		wizardCurrentStep,
		user,
		system,
		community
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetEquipments,
			fetchAddEquipment,
			fetchUpdateEquipment,
			fetchDeleteEquipment
		},
		dispatch
	);
	return { ...actions, dispatch };
};

const ConnectedPlaceWizard = connect(
	mapStateToProps,
	mapDispatchToProps
)(PlaceWizard);

export default {
	PlacesPage: connect(mapStateToProps, mapDispatchToProps)(PlacesPage),
	PlaceWizard: ConnectedPlaceWizard
};
